import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import {
  getTransactionCreditCardDetails,
  getTransactionJPMorganDetails,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import Checkbox from "@mui/material/Checkbox";
import CreditCardItems from "./credit-card/items";
import CreditCardRelatedRecords from "./credit-card/relatedRecords";
import CreditCardRelationship from "./credit-card/relationship";
import CreditCardSystemInformation from "./credit-card/systemInformation";
import CreditCardCustom from "./credit-card/custom";
import CreditCardEft from "./credit-card/eft";
import CreditCardCommunication from "./credit-card/communication";

export default function TransactionTypeCreditCard() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [discount, setDiscount] = useState("");
  const [gstHst, setGstHst] = useState("");
  const [pst, setPst] = useState("");
  const [total, setTotal] = useState("");
  const [jpMorganData, setJpMorganData] = useState([]);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocCreditMemoDetailsData();
    }
  }, []);

  async function getTransactionDocCreditMemoDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCreditCardDetails(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setlinkingdocumentno(data.data.linkingdocumentno);
      setSubTotal(data.data.subtotal);
      setDiscount(data.data.discount);
      setGstHst(data.data.gst_hst);
      setPst(data.data.pst);
      setTotal(data.data.total);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getJPMorganEftData() {
    try {
      const { data } = await getTransactionJPMorganDetails(user.token, {
        id: params.docNo,
      });
      setJpMorganData(data.data.data);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  useEffect(() => {
    if (user.token && tabIndex === 7) {
      getJPMorganEftData();
    }
  }, [tabIndex]);
  return loading ? (
    <>
    <Typography component="h4" fontWeight={500} className="pageTitle">
        Credit Card
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* Intercompany Management*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
             Intercompany Management
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Sales Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Credit Card
      </Typography>
      
      <Typography component="h5" sx={{ mb: 2 }}>
        {/* {rowData.map((d, i) => ( */}
        <span className="para-no"><strong>{rowData.vendor_name}</strong></span>
        {/* ))} */}
        {rowData?.status &&
        <Button className="blue-button" size="small" sx={{ ml: 1 }}>
          {rowData?.status}
        </Button>
        }
      </Typography>

      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">TRANSACTION NUMBER</p>
                <p className="tFormName">{rowData.transactionnumber}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">AMOUNT</p>
                <p className="tFormName">{rowData.amount}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">POSTING PERIOD</p>
                <p className="tFormName">{rowData.posting_period}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">REFERENCE #</p>
                <p className="tFormName">{rowData.reference}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">CURRENCY</p>
                <p className="tFormName">{rowData.currency}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">PC/PROJECT</p>
                <p className="tFormName">{rowData.pc_project}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">FILE NAME/MEMO</p>
                <p className="tFormName">{rowData.memo}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">EXCHANGE RATE</p>
                <p className="tFormName">{rowData.exchange_rate}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">PURCHASE REASON </p>
                <p className="tFormName">{rowData.purchase_reason}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">VENDOR</p>
                <p className="tFormName">{rowData.vendor_name}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">DATE</p>
                <p className="tFormName">{rowData.date}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel checkAndTextAlign">
                  {rowData.cc_reviewed_by_hhs_admin == "F" ||
                  rowData.cc_reviewed_by_hhs_admin == null ||
                  rowData.cc_reviewed_by_hhs_admin == "" ? (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label="CC REVIEWED BY HHS ADMIN"
                      />
                    </FormGroup>
                  ) : (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label="CC REVIEWED BY HHS ADMIN"
                      />
                    </FormGroup>
                  )}
                </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">ACCOUNT</p>
                <p className="tFormName">{rowData.account}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">BALANCE</p>
                <p className="tFormName">{rowData.balance}</p>
              </Grid>
            </Grid>
          </>
        </Box>
      </Box>
      {/*Address Information*/}
      {/* <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Address Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <Grid container className="mb-2">
              <Grid item xs={12} sm={5} md={5}>
                <p className="tFormlabel">BILL TO</p>
                <p className="tFormName">{rowData.bill_to}</p>
                <p className="tFormlabel">
                  <Link>Map</Link>
                </p>
              </Grid>
              <Grid item xs={12} sm={2} md={2}></Grid>
              <Grid item xs={12} sm={5} md={5}>
                <p className="tFormlabel">SHIP TO</p>
                <p className="tFormName">{rowData.ship_to}</p>
                <p className="tFormlabel">
                  <Link>Map</Link>
                </p>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box> */}

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SUBSIDIARY</p>
              <p className="tFormName">{rowData.subsidiary}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">DEPARTMENT</p>
              <p className="tFormName">{rowData.department}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SERVICE LINE</p>
              <p className="tFormName">{rowData.service_line}</p>
            </Grid>
          </Grid>
          {/* ))} */}
        </Box>
      </Box>

      {/*Intercompany management*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Intercompany Management
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData.interconnect_cc_transaction === "F" ? (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label=""
                      />
                    </FormGroup>
                    INTERCONNECT CC TRANSACTION
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label=""
                      />
                    </FormGroup>
                    INTERCONNECT CC TRANSACTION
                  </>
                )}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData.expense_pc_suspense === "F" ? (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label=""
                      />
                    </FormGroup>
                    EXPENSE PC SUSPENSE
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label=""
                      />
                    </FormGroup>
                    EXPENSE PC SUSPENSE
                  </>
                )}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">ORIGINAL INVOICE DATE</p>
              <p className="tFormName">{rowData.original_invoice_date}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">AVALARA CREATED FROM</p>
              <p className="tFormName">{rowData.avalara_created_from}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData.SEND_import_address_to_avatax === "F" ? (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label=""
                      />
                    </FormGroup>
                    SEND IMPORT ADDRESS TO AVATAX
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled checked />}
                        label=""
                      />
                    </FormGroup>
                    SEND IMPORT ADDRESS TO AVATAX
                  </>
                )}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">MIDDLE MAN VAT ID</p>
              <p className="tFormName">{rowData.middle_man_vat_id}</p>
            </Grid>
          </Grid>
          {/* ))} */}
        </Box>
      </Box>
      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Items" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="Relationships" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="JP Morgan" />
          </Tabs>

          {/*Items*/}
          <TabPanel value={tabIndex} index={0}>
            <CreditCardItems />
          </TabPanel>
          {/*Items*/}
          {/* Communication */}
          <TabPanel value={tabIndex} index={1}>
            {tabIndex === 1 && <CreditCardCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Communication */}

          {/* RelatedRecords */}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && (
              <CreditCardRelatedRecords tabIndexP={tabIndex} />
            )}
          </TabPanel>
          {/* RelatedRecords */}

          {/* Relationship */}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 &&    <CreditCardRelationship tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Relationship */}

          {/* SystemInformation */}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && <CreditCardSystemInformation />}
          </TabPanel>
          {/* SystemInformation */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <CreditCardCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Custom */}

          {/* Eft */}
          <TabPanel value={tabIndex} index={6}>
            <CreditCardEft tabIndexP={tabIndex} />
          </TabPanel>
          {/* Eft */}

          {/*-------------jp Morgan-----------*/}
          <TabPanel value={tabIndex} index={7}>
            <Box className="viewDetilsBox">
              {/* {tax_R_Data?.map((el, index) => (
              <Box className="viewDetilsBox" key={index}> */}
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN REFERENCE ID</p>
                  <p className="tFormName">{rowData.reference_id}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN STATUS</p>
                  <p className="tFormName">{rowData.status}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN MESSAGE</p>
                  <p className="tFormName">{rowData.message}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN UPDATED DATE</p>
                  <p className="tFormName">{rowData.updated_date}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN PAYER</p>
                  <p className="tFormName">{rowData.payer}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN TRANSACTION ID</p>
                  <p className="tFormName">{rowData.transaction_id}</p>
                </Grid>
              </Grid>
            </Box>
            {/* ))} */}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
